import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import AgreementsPage from "../screens/Agreements/AgreementsPage";
import AgreementDetails from "../screens/Agreements/AgreementDetails";

const Stack = createStackNavigator();

export const AgreementStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Agreement" component={AgreementsPage} />
      <Stack.Screen name="AgreementDetails" component={AgreementDetails} />
    </Stack.Navigator>
  );
};

export default AgreementStackNavigator;
